module.exports = __webpack_public_path__ + "img/ico_opt_display_show.f2985e99.svg";